//权限管理
const state = {
		//所有菜单权限集合
		all_Jurisdiction:[],
		//公共权限
		Public_Jurisdiction:[],
		//公共路由
		Public_router:[],
  }
  //同步
const mutations = {
			ALL_JURISDICTION:(state,jurisdiction)=>{
				state.all_Jurisdiction = jurisdiction
			},
			GET_PUBLIC_ROUTER:(state,jurisdiction)=>{
				state.Public_router = jurisdiction
			},
			GET_PUBLIC_JURISDICTION:(state,jurisdiction)=>{
				state.Public_Jurisdiction = jurisdiction
			},
  }
  //异步
const actions = {
		get_Public_router({commit},jurisdiction){
				commit('GET_PUBLIC_ROUTER', jurisdiction)
		},
		get_all_Jurisdiction({commit},jurisdiction){
				commit('ALL_JURISDICTION', jurisdiction)
		},
		get_Public_Jurisdiction({commit},jurisdiction){
				commit('GET_PUBLIC_JURISDICTION', jurisdiction)
		},
		
  }


export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Jurisdiction.js